export const showNotification = (title, content, buttonGroup) => {
  return (dispatch, getState) => {
    dispatch({
      type: "UPDATE_NOTIFICATION_SHOW",
      payload: true,
    });
    dispatch({
      type: "UPDATE_NOTIFICATION_TITLE",
      payload: title,
    });
    dispatch({
      type: "UPDATE_NOTIFICATION_CONTENT",
      payload: content,
    });
    dispatch({
      type: "UPDATE_NOTIFICATION_BUTTON_GROUP",
      payload: buttonGroup,
    });
  };
};

export const closeNotification = () => {
  return (dispatch, getState) => {
    dispatch({
      type: "UPDATE_NOTIFICATION_SHOW",
      payload: false,
    });
    dispatch({
      type: "UPDATE_NOTIFICATION_TITLE",
      payload: "",
    });
    dispatch({
      type: "UPDATE_NOTIFICATION_CONTENT",
      payload: "",
    });
    dispatch({
      type: "UPDATE_NOTIFICATION_BUTTON_GROUP",
      payload: <></>,
    });
  };
};
